<div fxLayout="column" class="margin-top-8 margin-x-3 margin-bottom-4" fxLayoutGap="12px">
  <h4 class="text-title font-bold margin-0 text-left">{{ competition.title ? competition.title : 'Untitled Competition' }}</h4>
  <h5 class="text-desc sparro-grey-800 font-regular text-left margin-0">
    {{ competition.tagline ? competition.tagline : 'No tagline' }}
  </h5>
</div>
